import { includes } from 'lodash-es';

import type { AuthUser } from './types';

export function userMustAcceptPrivacyPolicy(user: AuthUser): boolean {
    const acceptanceIsStale = Boolean(
        user.currentPolicy?.[0] && user.acceptedVersionPP?.toString() !== user.currentPolicy[0].majorVersion.toString()
    );

    return acceptanceIsStale && includes(user.permissions, 'SubscriberPP_Read');
}
